/**
 * @file コンポーネント：フル動画ページローディングエラーモーダル ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const ModalErrorLoading = (props) => {
    // Presenterに渡す
    return <Presenter setIsShow={props.setIsShow} />;
};
